import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { TypeFacture, WorkflowConfig, WorkflowValidationRow } from '@/lib/database.types';

export function useWorkflows(entrepriseId: string | null) {
  return useQuery({
    queryKey: ['workflows', entrepriseId],
    enabled: !!entrepriseId,
    queryFn: async (): Promise<WorkflowValidationRow[]> => {
      if (!entrepriseId) return [];
      const { data, error } = await supabase
        .from('workflows_validation')
        .select('*')
        .eq('entreprise_id', entrepriseId)
        .order('type_facture');
      if (error) throw error;
      return data;
    },
  });
}

export function useSaveWorkflow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      entreprise_id: string;
      type_facture: TypeFacture;
      config: WorkflowConfig;
    }): Promise<WorkflowValidationRow> => {
      const { data, error } = await supabase
        .from('workflows_validation')
        .upsert(input, { onConflict: 'entreprise_id,type_facture' })
        .select('*')
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: (row) => {
      void qc.invalidateQueries({ queryKey: ['workflows', row.entreprise_id] });
    },
  });
}
